var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#FF7D7D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2956 23.568H19.7047C20.5583 23.568 21.2502 22.8761 21.2502 22.0226L21.603 13.5547C21.6213 13.1157 21.2703 12.7498 20.8309 12.7498H13.1694C12.73 12.7498 12.3791 13.1157 12.3974 13.5547L12.7502 22.0226C12.7502 22.8761 13.4421 23.568 14.2956 23.568Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8184 12.7498H23.182M14.682 10.4316H19.3184M19.7047 23.568H14.2956C13.4421 23.568 12.7502 22.8761 12.7502 22.0226L12.3974 13.5547C12.3791 13.1157 12.73 12.7498 13.1694 12.7498H20.8309C21.2703 12.7498 21.6213 13.1157 21.603 13.5547L21.2502 22.0226C21.2502 22.8761 20.5583 23.568 19.7047 23.568Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/deleteButton.bf0a1d9fe6e6c584965426ace0d4870a.svg";
export { ForwardRef as ReactComponent };